import { Seo } from '../components/Seo';
import { Icon } from '../components/Icon';
import { CtaSection } from '../components/Sections';
import { useT } from '../i18n';
import { buildTitle } from '../lib/site';

export function FeesPage() {
  const t = useT();
  const p = t.pages.fees;
  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.lead}
        path="/fees"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{p.lead}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="callout" style={{ marginBottom: 48 }}>
            <div className="title">{p.zeroTitle}</div>
            <p>{p.zeroDesc}</p>
          </div>

          <table className="fee-table">
            <thead>
              <tr>
                {p.tableHeaders.map((h) => (<th key={h}>{h}</th>))}
              </tr>
            </thead>
            <tbody>
              {p.rows.map((f) => (
                <tr key={f.label}>
                  <td>{f.label}</td>
                  <td className="mono">{f.value}</td>
                  <td style={{ color: 'var(--text-muted)' }}>{f.note}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ marginTop: 48 }}>
            <div className="section-head">
              <span className="eyebrow">{p.includedEyebrow}</span>
              <h2>{p.includedTitle}</h2>
            </div>
            <ul style={{ listStyle: 'none', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
              {p.included.map((item) => (
                <li key={item} className="card" style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: 20 }}>
                  <Icon name="check" width={20} height={20} style={{ color: 'var(--mint)', flexShrink: 0, marginTop: 2 }} />
                  <span style={{ color: 'var(--text)', fontSize: 14.5, lineHeight: 1.6 }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaSection />
    </>
  );
}
